import {
  getEmptyContent,
  isDisplay,
  isValidData,
  RelatedLinks
} from '@com-delta-idp/mnx-skymiles-shared';
import { logError } from '@com-delta-idp/mnx-utils';
import { AEMRelatedLinks } from '../models';

export const getRelatedLinks = (
  links: AEMRelatedLinks | undefined,
  featureFlag: boolean | undefined
): RelatedLinks => {
  try {
    return isValidData<
      AEMRelatedLinks,
      [AEMRelatedLinks | undefined, boolean | undefined]
    >('relatedLinkList', links, featureFlag)
      ? adaptRelatedLinks(links as AEMRelatedLinks, featureFlag as boolean)
      : isDisplay<RelatedLinks>(featureFlag);
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'OVERVIEW', 'RELATED_LINKS');
    // TODO(Sabarish, Sai): To handle error message for Summary component
    return getEmptyContent<RelatedLinks>('', [], true, true);
  }
};

const adaptRelatedLinks = (
  links: AEMRelatedLinks,
  featureFlag: boolean
): RelatedLinks => {
  return {
    links: links.relatedLinkList,
    disabled: !featureFlag,
    loaded: true
  };
};
